module.exports = __webpack_public_path__ + "static/files/acv_twoFiguresTalking.fecfbda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acv_twoFiguresTalking.png
// module id = iCCW
// module chunks = 0